import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { Review } from './review.model';

export interface ReviewState extends EntityState<Review> {}

@Injectable()
@StoreConfig({
  name: 'review',
})
export class ReviewStore extends EntityStore<ReviewState> {
  constructor() {
    super();
  }
}
